import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Suppress React error overlay for third-party widget errors
if (process.env.NODE_ENV === 'development') {
  // Hide webpack error overlay iframe
  const hideErrorOverlay = () => {
    const errorOverlay = document.getElementById('webpack-dev-server-client-overlay');
    if (errorOverlay) {
      errorOverlay.style.display = 'none';
    }
  };
  
  // Check for overlay every 500ms
  setInterval(hideErrorOverlay, 500);
  
  // Also suppress error events
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('Cannot read properties of null')) {
      e.stopImmediatePropagation();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
